import { render } from "./FiebreDeBaile.vue?vue&type=template&id=1dccf213&scoped=true"
import script from "./FiebreDeBaile.vue?vue&type=script&lang=js"
export * from "./FiebreDeBaile.vue?vue&type=script&lang=js"

import "./FiebreDeBaile.vue?vue&type=style&index=0&id=1dccf213&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dccf213"]])

export default __exports__